
import axios from "axios";

export const state = {
    staffallowances: [],
};

export const getters = {
    staffallowances: state => state.staffallowances,
};

export const mutations = {
    setStaffAllowances(state, newValue) {
        state.staffallowances = newValue
    },
};

export const actions = {
    fetchStaffAllowances({ commit }) {
        axios.get('/staffallowances').then(res => {
            commit('setStaffAllowances', res.data.staffallowances);
        })
    },
};
